import { j as t } from "./kezios-design-system.esm172.js";
import { Container as p, Stack as l, Flex as o } from "@mantine/core";
import { BlogCard as c } from "./kezios-design-system.esm110.js";
import f from "./kezios-design-system.esm186.js";
import { SectionLayout as x } from "./kezios-design-system.esm96.js";
import { SectionHeader as j } from "./kezios-design-system.esm125.js";
import { Spacing as r } from "./kezios-design-system.esm135.js";
const g = ({
  children: i,
  category: s,
  title: a,
  subtitle: n,
  cta: m,
  ...e
}) => /* @__PURE__ */ t.jsx(
  p,
  {
    style: { width: "100%" },
    size: "100%",
    bg: "gray.0",
    py: r.s24,
    ...e,
    children: /* @__PURE__ */ t.jsx(x, { ...e, children: /* @__PURE__ */ t.jsxs(l, { gap: r.s16, children: [
      /* @__PURE__ */ t.jsxs(
        o,
        {
          className: f.headerContainer,
          align: "flex-start",
          justify: "space-between",
          rowGap: r.s4,
          children: [
            /* @__PURE__ */ t.jsx(
              j,
              {
                category: s,
                title: a,
                subtitle: n,
                variant: "left",
                titleComponent: "h1"
              }
            ),
            m
          ]
        }
      ),
      /* @__PURE__ */ t.jsx(
        o,
        {
          justify: "center",
          align: "flex-start",
          gap: r.s8,
          wrap: "wrap",
          children: i
        }
      )
    ] }) })
  }
);
g.Item = c;
export {
  g as BlogSection
};
